import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder for any list. Wraps SortableJS.
//
// HTML:
//   <ul data-controller="sortable"
//       data-sortable-url-value="/scoring_rules/reorder"
//       data-sortable-param-value="ids"
//       data-sortable-handle-value=".drag-handle">
//     <li data-sortable-id="1">...</li>
//     <li data-sortable-id="2">...</li>
//   </ul>
//
// On drop, POSTs `param_value=[ordered_ids]` to `url_value` with CSRF token.
// Server is expected to update `position` and respond 204/200.
export default class extends Controller {
  static values = {
    url: String,
    param: { type: String, default: "ids" },
    handle: { type: String, default: ".drag-handle" },
    animation: { type: Number, default: 150 }
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: this.animationValue,
      handle: this.handleValue,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async persist() {
    if (!this.urlValue) return

    const ids = Array.from(this.element.querySelectorAll("[data-sortable-id]"))
      .map((el) => el.dataset.sortableId)

    const formData = new FormData()
    ids.forEach((id) => formData.append(`${this.paramValue}[]`, id))

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const headers = { "Accept": "application/json" }
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken

    try {
      const response = await fetch(this.urlValue, { method: "PATCH", headers, body: formData })
      if (!response.ok) console.warn(`[sortable] reorder PATCH ${this.urlValue} → ${response.status}`)
    } catch (error) {
      console.warn("[sortable] reorder failed", error)
    }
  }
}
